export default "__VITE_ASSET__CZpqeswU__"